import { render, staticRenderFns } from "./OtpAutoClient.vue?vue&type=template&id=bee4145a&"
import script from "./OtpAutoClient.vue?vue&type=script&lang=ts&"
export * from "./OtpAutoClient.vue?vue&type=script&lang=ts&"
import style0 from "./OtpAutoClient.vue?vue&type=style&index=0&id=bee4145a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports